var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.88889C4 4.65314 4.09365 4.42705 4.26035 4.26035C4.42705 4.09365 4.65314 4 4.88889 4H19.1111C19.3469 4 19.573 4.09365 19.7397 4.26035C19.9064 4.42705 20 4.65314 20 4.88889V7.18756C19.9999 7.42328 19.9063 7.64934 19.7396 7.816L14.0382 13.5173C13.8715 13.684 13.7778 13.91 13.7778 14.1458V16.4444L10.2222 20V14.1458C10.2222 13.91 10.1285 13.684 9.96178 13.5173L4.26044 7.816C4.09373 7.64934 4.00005 7.42328 4 7.18756V4.88889Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.9ce77d98f980f41a3524997d414636f1.svg";